import React, { useState, useEffect } from 'react';

import { Select } from 'antd';

import { IBVControl } from '../../../models/BVControls/IBVControl';
import { IBVOption } from '../../../models/BVControls/IBVOption';

import './bv-combo-box.scss';

import BVControl from '../BVControl/bv-control';

interface IBVComboBox extends IBVControl {
    data: IBVOption[];
    properties: any;
}

const BVComboBox: React.FunctionComponent<IBVComboBox> = ({ className, data, errorMessage, infoMessage, label, properties, required, isEmbedded, isToShow }) => {
    const [controlData, setControlData] = useState(data.slice());

    const _handleFilterChange = (input: string, option: any) => (
        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );

    useEffect(() => {
        setControlData(data.slice());
    }, [data]);

    return (
        <BVControl className={`bv-combo-box ${className}`} errorMessage={errorMessage} infoMessage={infoMessage} label={label} required={required}>
            {
                isEmbedded ?
                <Select
                    {...properties}
                    options={controlData}
                    showSearch
                    optionFilterProp="children"
                    filterOption={_handleFilterChange}
                    open={isToShow}
                /> :
                <Select
                    {...properties}
                    options={controlData}
                    showSearch
                    optionFilterProp="children"
                    filterOption={_handleFilterChange}
                />
            }
        </BVControl>
    );
}

export default BVComboBox;